import Constants from "./Constants";

class ImagePreloader {
	constructor(arr, complete, update) {
		this.data = arr;
		this.index = 0;
		this.complete = complete;
		this.update = update;
		this.initLoad();
	}

	initLoad = () => {
		this.loadImage(this.data[this.index]);
	};

	loadImage = url => {
		var img = new Image();
		img.addEventListener("load", event => {
			this.index += 1;

			if (this.update) this.update(this.index / this.data.length);

			if (this.index < this.data.length) {
				this.initLoad();
			} else {
				if (this.complete) this.complete();
			}
		});
		img.addEventListener("error", error => {
			console.warn(error);
		});
		img.src = `${Constants.IMAGE_PATH_PREFIX}${this.data[this.index]}`;
	};
}

export default ImagePreloader;



// WEBPACK FOOTER //
// ./src/ImagePreloader.js